import React from 'react';
import { DEVICE_TYPES, TDeviceFormValues } from '../types';
import { restGetRegistersMonitoredObjects } from '@/app/services/registers/monitoredObjects';
import { IDevice } from '@/app/state/types';

const defaultValues: TDeviceFormValues = {
    data: {
        autoGenerateId: true,
        id: '',
        deviceType: '',
        serialNumber: '',
        monitoredObjectId: null,
        password: '',
        passwordConfirmation: '',
    },
    advanced: {
        eToll: {
            enabled: false,
            businessNumber: '',
            pin: '',
        },
    },
};

export const getDeviceTypeFromSerialNumber = (
    serialNumber: string,
    deviceTypes: { id: string; name: string }[]
) => {
    if (!serialNumber) return { typeId: '', serial: '' };

    const match = deviceTypes.find(
        (d) => d.id !== 'other' && serialNumber.startsWith(d.id)
    );

    if (match) {
        return {
            typeId: match.id,
            serial: serialNumber.replace(match.id, ''),
        };
    }

    return { typeId: 'other', serial: serialNumber };
};

export const useDeviceInitialValues = (selectedDevice?: IDevice) => {
    const [initialValues, setInitialValues] =
        React.useState<TDeviceFormValues | null>(null);

    React.useEffect(() => {
        const loadInitialValues = async () => {
            if (!selectedDevice) {
                setInitialValues(defaultValues);
                return;
            }

            const { typeId, serial } = getDeviceTypeFromSerialNumber(
                selectedDevice.serialNumber,
                DEVICE_TYPES
            );
            const objects = await restGetRegistersMonitoredObjects();
            const monitoredObject = objects.find(
                (obj) => Number(obj.id) === selectedDevice.monitoredObjectId
            );
            setInitialValues({
                data: {
                    autoGenerateId: true,
                    deviceType: typeId,
                    id: selectedDevice.id,
                    serialNumber: serial,
                    monitoredObjectId: monitoredObject ?? null,
                    password: '',
                    passwordConfirmation: '',
                },
                advanced: {
                    eToll: {
                        enabled: Boolean(selectedDevice.attributes?.eToll),
                        businessNumber:
                            selectedDevice.integrations?.eToll.businessNumber,
                        pin: selectedDevice.integrations?.eToll.pin,
                    },
                },
            });
        };

        loadInitialValues();
    }, [selectedDevice]);

    return initialValues;
};
